import React, { useCallback } from 'react'

import { NOOP } from 'constants/commonConstans'

import CollapseIcon from '../CollapseIcon'
import * as s from './DefaultHeader.module.scss'

interface IDefaultHeaderProps {
  open: boolean
  toggle: () => void
  iconPosition?: 'left' | 'right' | 'none'
  children: React.ReactElement | string
  gap?: number
  collapsible: 'full' | 'icon'
}

const DefaultHeader: React.FC<IDefaultHeaderProps> = ({
  children,
  open,
  iconPosition = 'left',
  collapsible,
  toggle,
  gap,
}) => {
  const handleIconClick = useCallback(
    () => (collapsible === 'icon' ? toggle() : NOOP),
    [toggle, collapsible],
  )

  return (
    <div className={s.root} style={{ gap }}>
      {iconPosition === 'left' && (
        <CollapseIcon iconPosition='left' onClick={handleIconClick} open={open} />
      )}
      <div className={s.headerContent}>{children}</div>
      {iconPosition === 'right' && (
        <CollapseIcon iconPosition='right' onClick={handleIconClick} open={open} />
      )}
    </div>
  )
}

export default DefaultHeader
